export interface AppSettings {
  appVersion: string;
  webAppUrl: string;
  sentryEnvironment: string;
  userManager: {
    authority: string;
    client_id: string;
    redirect_uri: string;
    response_type: string;
    scope: string;
    post_logout_redirect_uri: string;
    silent_redirect_uri: string;
    automaticSilentRenew: string;
  };
}

export const getAppSettings = async (): Promise<AppSettings> => {
  const response = await fetch('/enrolments/appsettings.json');
  if (!response.ok) {
    throw new Error('Failed to load app settings');
  }
  return response.json();
};
